// extracted by mini-css-extract-plugin
module.exports = {"info":"BonusesType_info_21_GM"};